import { Box, Tab, Tabs } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ProductMasterTab from '../ProductMaster/ProductMasterTab';
import useAuth from 'hooks/useAuth';
import LeadTimesTab from '../LeadTimes/LeadTimesTab';

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

export default function SettingsMainComponent() {
	const { user } = useAuth();

	const isAdmin = user.permissions.includes('ProductViewManage:Admin');
	const isViewer = user.permissions.includes('ProductViewManage:View');

	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="basic tabs example"
					variant="fullWidth"
				>
					{/* <Tab label="INVENTARIO" {...a11yProps(0)} />
					<Tab label="EVENTOS" {...a11yProps(1)} />
					<Tab label="CICLO DE VIDA" {...a11yProps(2)} /> */}
					{(isAdmin || isViewer) && <Tab label="LEADTIMES" {...a11yProps(0)} />}

					{(isAdmin || isViewer) && (
						<Tab label="MAESTRO DE PRODUCTOS" {...a11yProps(1)} />
					)}
				</Tabs>
			</Box>
			{/* <CustomTabPanel value={value} index={0}>
				<InventoryTab />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}>
				<EventsProvider>
					<EventsFiltersProvider>
						<EventsTab />
					</EventsFiltersProvider>
				</EventsProvider>
			</CustomTabPanel>
			<CustomTabPanel value={value} index={2}>
				<LifeCycleTab />
			</CustomTabPanel> */}
			<CustomTabPanel value={value} index={0}>
				<LeadTimesTab />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}>
				<ProductMasterTab />
			</CustomTabPanel>
		</Box>
	);
}
